import client from "@/libs/client.ts";
import type { Balance } from "@/types/account";

const update = async (balance: Balance): Promise<boolean> => {
  const response = await client.put("account/balance", { amount: balance });

  return response.status === 204;
};

export { update };
